import {
    SET_PERMISSIONS
} from './types'

export const setPermissions = (params) => ({
    type: SET_PERMISSIONS,
    payload: params
})